import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategorySection() {
  const colorMap: Record<string, { bg: string; iconBg: string; hover: string }> = {
    primary: {
      bg: 'bg-primary-500',
      iconBg: 'bg-primary-100/20',
      hover: 'hover:bg-primary-500',
    },
    accent: {
      bg: 'bg-accent-500',
      iconBg: 'bg-accent-100/20',
      hover: 'hover:bg-accent-500',
    },
    secondary: {
      bg: 'bg-secondary-500',
      iconBg: 'bg-secondary-100/20',
      hover: 'hover:bg-secondary-500',
    },
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section header */}
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-foreground-500 border border-background-300 rounded-full mb-3">
            分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            探索你喜欢的动漫类型
          </h2>
          <p className="text-foreground-500 text-sm">
            按类型、地区和年份筛选，快速找到你感兴趣的动漫
          </p>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group relative p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 transition-all duration-300 cursor-pointer ${colors.hover} hover:text-white hover:border-transparent`}
              >
                {/* Icon */}
                <div
                  className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg ${colors.iconBg} mb-3 group-hover:bg-white/20 transition-colors duration-300`}
                >
                  <i
                    className={`${cat.icon} text-lg md:text-xl group-hover:text-white transition-colors duration-300 ${
                      cat.color === 'primary'
                        ? 'text-primary-500'
                        : cat.color === 'accent'
                          ? 'text-accent-500'
                          : 'text-secondary-500'
                    }`}
                  ></i>
                </div>

                {/* Text */}
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-white transition-colors duration-300 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 group-hover:text-white/70 transition-colors duration-300 mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-300 group-hover:text-white/50 transition-colors duration-300">
                  {cat.count.toLocaleString()} 部作品
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}